import { useMerchant } from "@/hooks/useMerchant";
import { useTRPC } from "@/trpc/client";
import { useQuery } from "@tanstack/react-query";

export function useFetchApprovedTopUps() {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const { data, isLoading } = useQuery(
    trpc.topUps.list.queryOptions(
      { rentalsMerchantId: merchant?.id ?? "", statuses: ["approved"] },
      { enabled: !!merchant?.id }
    )
  );

  return { topUps: data?.data ?? [], isLoading };
}
